module.exports = __webpack_public_path__ + "static/bauble-104fc64a46bc935bb2bcef1e2ab5d74e.svg";